/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ChatWrite
 */
export interface ChatWrite {
    /**
     *
     * @type {string}
     * @memberof ChatWrite
     */
    name?: string;
}

/**
 * Check if a given object implements the ChatWrite interface.
 */
export function instanceOfChatWrite(value: object): value is ChatWrite {
    return true;
}

export function ChatWriteFromJSON(json: any): ChatWrite {
    return ChatWriteFromJSONTyped(json, false);
}

export function ChatWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatWrite {
    if (json == null) {
        return json;
    }
    return {

        'name': json['name'] == null ? undefined : json['name'],
    };
}

  export function ChatWriteToJSON(json: any): ChatWrite {
      return ChatWriteToJSONTyped(json, false);
  }

  export function ChatWriteToJSONTyped(value?: ChatWrite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
    };
}
